import { render, staticRenderFns } from "./EmployeeIndividualLeaveTable.vue?vue&type=template&id=e796b35c&scoped=true&"
import script from "./EmployeeIndividualLeaveTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeIndividualLeaveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e796b35c",
  null
  
)

export default component.exports